import axios from "axios";
import { Config } from "../../data/config";
export function fetchBuildingByPlaceId(placeId) {
  return function (dispatch) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${Config.frontApiUrl}/availability/places`, { 'place_id': placeId })
        .then(response => {
          resolve(response.data[0]);
        })
        .catch(error => {
          reject(error);
        })
    });
  };
}



// WEBPACK FOOTER //
// ./src/store/actions/building-by-place.js